export default __webpack_public_path__ + "static/media/FlagIcon.77d6d44f.svg";